export function relativeTime(ts: number | null | undefined): string {
  if (!ts) return 'never';
  const now = Math.floor(Date.now() / 1000);
  const diff = now - ts;
  if (diff < 0) {
    const ahead = Math.abs(diff);
    if (ahead < 60) return `in ${ahead}s`;
    if (ahead < 3600) return `in ${Math.floor(ahead / 60)}m`;
    if (ahead < 86400) return `in ${Math.floor(ahead / 3600)}h`;
    return `in ${Math.floor(ahead / 86400)}d`;
  }
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}

export function absoluteTime(ts: number | null | undefined): string {
  if (!ts) return '';
  return new Date(ts * 1000).toLocaleString();
}

export function shortHash(h: string | null | undefined): string {
  if (!h) return '';
  return h.length > 12 ? h.slice(0, 8) + '…' : h;
}

export function bytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / 1024 / 1024).toFixed(1)} MB`;
  if (n < 1024 * 1024 * 1024 * 1024) return `${(n / 1024 / 1024 / 1024).toFixed(1)} GB`;
  return `${(n / 1024 / 1024 / 1024 / 1024).toFixed(1)} TB`;
}
